import React from 'react';
import './App.css';
import 'semantic-ui-css/semantic.min.css';
import { Navbar, Footer, Banner, ProductSection, VideoSection, AboutSection } from './sections';

function App() {

  const homeRef = React.createRef();
  const productRef = React.createRef();
  const videoRef = React.createRef();
  const aboutRef = React.createRef();
  const contactRef = React.createRef();

  // handles navbar item click
  const handleItemClick = (e) => {
    const id = e.target.id;
    console.log("clicked", id);
    switch (id) { // Scroll-animation pointer logic
        case 'home':
            window.scrollTo({behavior: 'smooth', top: homeRef.current.offsetTop});
            break;
        case 'product':
            window.scrollTo({behavior: 'smooth', top: productRef.current.offsetTop});
            break;
        case 'video':
            window.scrollTo({behavior: 'smooth', top: videoRef.current.offsetTop});
            break;
        case 'about':
            window.scrollTo({behavior: 'smooth', top: aboutRef.current.offsetTop});
            break;
        case 'contact':
            window.scrollTo({behavior: 'smooth', top: contactRef.current.offsetTop});
            break;
        default:
            break;
      }
  }
  return (
    <div className="App">
      <Navbar handleItemClick={handleItemClick}/>
      <div ref={homeRef}>
        <Banner/>
      </div>
      <div ref={productRef}>
        <ProductSection/>
      </div>
      <div ref={videoRef}>
        <VideoSection />
      </div>
      <div ref={aboutRef}>
        <AboutSection/>
      </div>
      <div ref={contactRef}>
        <Footer/>
      </div>
    </div>
  );
}

export default App;
